/* eslint-disable max-lines-per-function */
import { Badge } from '@e2n/ui';
import { ArbeitsbereichOption } from '@/domain/mitarbeiter/features/rotationsplan/entities/ArbeitsbereichOption';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/entities/Mitarbeiter';
import { Select } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Select';
import { useArbeitsbereicheOptions } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useArbeitsbereicheOptions/useArbeitsbereicheOptions';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function ArbeitsbereichSelect({
  handleChange,
  standortId,
  mitarbeiter,
  value,
  disabled = false,
}: {
  handleChange: (arbeitsbereich: ArbeitsbereichOption) => void;
  standortId: string;
  mitarbeiter: Mitarbeiter;
  value: ArbeitsbereichOption;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  const { arbeitsbereiche } = useArbeitsbereicheOptions([standortId]);

  return (
    <Select<ArbeitsbereichOption>
      disabled={disabled}
      selectedOption={value}
      onChange={handleChange}
      drawerLabel={t(
        'domain.mitarbeiter.rotationsplan.rotationsplaene.createStation.fields.arbeitsbereich.label',
      )}
      options={arbeitsbereiche}
      renderTriggerContent={(selectedArbeitsbereich) =>
        selectedArbeitsbereich ? (
          <div className="flex items-center gap-2">
            <FontAwesomeIcon
              color={
                disabled
                  ? selectedArbeitsbereich.getFillColor()
                  : selectedArbeitsbereich.getBorderColor()
              }
              icon={faCircle}
            />
            <div className="whitespace-nowrap truncate text-sm font-normal">
              {selectedArbeitsbereich.name}
            </div>
          </div>
        ) : (
          <div>{t('actions.auswaehlen')}</div>
        )
      }
      renderListItem={(arbeitsbereich) => (
        <div className="flex items-center gap-2">
          <FontAwesomeIcon
            color={arbeitsbereich.getBorderColor()}
            icon={faCircle}
          />
          <div className="whitespace-nowrap truncate text-sm font-normal">
            {arbeitsbereich.name}
          </div>
          {mitarbeiter.arbeitsbereich?.id === arbeitsbereich.id && (
            <Badge type="pill" variant="secondary">
              {t('domain.mitarbeiter.rotationsplan.primaererArbeitsbereich')}
            </Badge>
          )}
        </div>
      )}
    />
  );
}
